import { render, staticRenderFns } from "./OperaChangeCompanyWindow.vue?vue&type=template&id=cb46c906&scoped=true&"
import script from "./OperaChangeCompanyWindow.vue?vue&type=script&lang=js&"
export * from "./OperaChangeCompanyWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaChangeCompanyWindow.vue?vue&type=style&index=0&id=cb46c906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb46c906",
  null
  
)

export default component.exports